import { takeLatest, put, call } from 'redux-saga/effects'

import {
  GET_PRACTICE_REPORT_REQUESTED,
  GET_PRACTICE_REPORT_SUCCESS,
  GET_PRACTICE_REPORT_FAILURE,
} from '../constants/constant.action'
import { api } from '../services'

function* getPracticeReportsSaga(action) {
  try {
    const result = yield call(api.getpracticeReportList, action.payload)
    if (result.status === 200) {
      yield put({
        type: GET_PRACTICE_REPORT_SUCCESS,
        payload: result.data,
      })
    } else {
      yield put({
        type: GET_PRACTICE_REPORT_FAILURE,
        payload: result.response.data.error.message,
      })
    }
  } catch (error) {
    yield put({ type: GET_PRACTICE_REPORT_FAILURE, error })
  }
}

export function* practiceReportsWatcherSaga() {
  yield takeLatest(GET_PRACTICE_REPORT_REQUESTED, getPracticeReportsSaga)
}
